/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Step1_BodyInputs */

const cs_sreality_step1_body = /** @type {(inputs: Sreality_Step1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivujte kancelář na Firmy.cz / Peněžence a sem vložte client id, software key a heslo. To je smlouva RK — sdílí ji každý export inzerátu.`)
};

const en_sreality_step1_body = /** @type {(inputs: Sreality_Step1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activate the agency on Firmy.cz / Peněženka, then paste the import client id, software key and password here. This is the RK contract — shared by every listing export.`)
};

/**
* | output |
* | --- |
* | "Activate the agency on Firmy.cz / Peněženka, then paste the import client id, software key and password here. This is the RK contract — shared by every listi..." |
*
* @param {Sreality_Step1_BodyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_step1_body = /** @type {((inputs?: Sreality_Step1_BodyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Step1_BodyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_step1_body(inputs)
	return cs_sreality_step1_body(inputs)
});